<template>
    <v-layout column align-center class="text-center">
        <title-rounded title="보물을 선택하세요!">
            <v-row justify="center" class="ma-n1">
                <v-col cols="6" md="4" class="pa-1" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0">
                    <event-card image="/images/event/hunt/event-img" @click="hunt" />
                </v-col>
                <v-col cols="6" md="4" class="pa-1" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 100 : 0">
                    <event-card image="/images/event/hunt/event-img2" @click="hunt" />
                </v-col>
            </v-row>
            <v-row justify="center" class="ma-n1">
                <v-col cols="6" md="4" order="2" order-md="1" class="pa-1" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 100 : 0">
                    <event-card image="/images/event/hunt/event-img3" @click="hunt"/>
                </v-col>
                <v-col cols="12" md="4" order="1" order-md="2" class="pa-1" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 150 : 0">
                    <div class="mw-50 mw-md-100 mx-auto">
                        <event-card image="/images/event/hunt/event-img4" @click="hunt"/>
                    </div>
                </v-col>
                <v-col cols="6" md="4" order="3" class="pa-1" data-aos="fade-up" data-aos-duration="700" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 200 : 0">
                    <event-card image="/images/event/hunt/event-img5" @click="hunt"/>
                </v-col>
            </v-row>
        </title-rounded>
        <congratulation-dialog ref="congratulationdialog" />
        <already-dialog ref="alreadydialog"/>
    </v-layout>
</template>

<script>
import api from '@/api';
import TitleRounded from "@/components/client/event/hunt/title-rounded.vue";
import EventCard from "@/components/client/event/hunt/event-card.vue";
import AlreadyDialog from "@/components/client/event//hunt/already-dialog.vue";
import CongratulationDialog from "@/components/client/event//hunt/congratulation-dialog.vue";

export default {
    components: {
        TitleRounded,
        EventCard,
        CongratulationDialog,
        AlreadyDialog,
    },
    data() {
        return {
            config: null
        }
    },
    methods: {
        async hunt() {
            if (this.logon) {
                let { log } = await api.v1.hunt.logs.confirm();

                if(!log) {
                    let { config } = await api.v1.hunt.logs.post();
                    this.config = config;
                    this.$refs.congratulationdialog.open(this.config)
                } else {
                    this.$refs.alreadydialog.open()
                }
            } else {
                alert("보물찾기 이벤트는 로그인 후 참여할 수 있습니다.");
                this.$router.push("/login");
            }
        }
    },
    computed: {
        logon() {
            return !!this.$store.state.accessToken;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";

</style>